import React from 'react';
// @ts-ignore
import { Card } from '@els/els-react--card';
// @ts-ignore
import { LinkElement } from '@els/els-react--link-element';
import './updates-cards.scss';

const UpdatesCard = (props: any) => {
    const { description, buttonText, onClickNavigateTo, href } = props;
    const baseClassName = 'updates-card';
    return (
        <Card className={`${baseClassName}`} borderWeight="none">
            <div className={`${baseClassName}__container`}>
                <div className={`${baseClassName}__container__content-wrapper`}>
                    <div className={`${baseClassName}__content-wrapper__text`}>
                        {description}
                    </div>
                </div>
                <LinkElement
                    href={href}
                    iconSprite="ChevronRight"
                    iconSize="xs"
                    iconRight
                    inline
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        onClickNavigateTo();
                    }}
                >
                    {buttonText}
                </LinkElement>
            </div>
        </Card>
    );
};

export default UpdatesCard;
